import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {Link, useLocation, useParams} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {
    getCurrentCategoryType,
    resetUpdateCategoryTypeStatus,
    updateCategoryType
} from "../../store/reducers/CategoryTypesSlice";
import {RequestStatus} from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface ModifyCategoryTypeScreenProps {
}

export interface ModifyCategoryTypeFormProps {
    name: string;
    order: number;
}

export const ModifyCategoryTypeScreen: React.FC<ModifyCategoryTypeScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();

    const {id} = useParams();

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const requestStatus: RequestStatus = categoryTypesState.updateCategoryTypeStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupi tüübid', url: '/category-types'},
        {text: 'Muuda tüüpi', url: '/category-types/modify/'},
    ];

    useEffect(() => {
        dispatch(resetUpdateCategoryTypeStatus());
    }, [location]);

    useEffect(() => {
        dispatch(getCurrentCategoryType({id}));
    }, [id]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            name: categoryTypesState?.currentCategoryType?.name ?? '',
            order: categoryTypesState?.currentCategoryType?.order_nr ?? ''
        },
        onSubmit: (values: any) => {
            dispatch(updateCategoryType({id, data: values}));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success &&
            <div className="message msg-ok">
              <div>
                <h2>Andmed muudetud</h2>
              </div>
            </div>
            }
            {requestStatus === RequestStatus.Failed && categoryTypesState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {categoryTypesState.errors.map((error, index) => (
                            <span key={index}>{error}<br /></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2><span>Grupi tüübi andmed</span></h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true}/>
                            <ElogInput label="Järjekorra number" name="order" mandatory={false}/>
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                <span><strong>Muuda</strong></span>
                            </button>
                            <Link to="/category-types">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    )

}